<template>
  <v-col class="primary--text py-5">
    <v-row>
      {{ inputTitle }}
    </v-row>
    <v-row align="center" justify="space-around">
      <v-select
        v-if="type == 'select'"
        class="input-custom py-0 pl-5 pr-0"
        :class="{ disabledInput: disabled }"
        flat
        solo
        hide-details
        v-model="value"
        :items="config.GENDERS"
        :disabled="disabled"
      >
        <template v-slot:append v-if="!disabled">
          <v-icon size="large" color="secondary" @click="clearInput()">
            close
          </v-icon>
        </template>
        <template v-slot:selection="data">
          <div class="pr-10">
            {{ $t(`gender.${data.item}`) }}
          </div>
        </template>
        <template v-slot:item="data">
          <div class="pr-10">
            {{ $t(`gender.${data.item}`) }}
          </div>
        </template>
      </v-select>
      <v-text-field
        v-else-if="type != 'date'"
        :disabled="disabled"
        flat
        solo
        hide-details
        single-line
        :type="type"
        v-model="value"
        class="input-custom py-0 pl-5 pr-0"
        :class="{ disabledInput: disabled }"
      >
        <template v-slot:append v-if="!disabled">
          <v-icon size="large" color="secondary" @click="clearInput">
            close
          </v-icon>
        </template>
      </v-text-field>
      <v-dialog
        v-else
        ref="dialog"
        v-model="modal"
        persistent
        width="290px"
        :disabled="disabled"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            readonly
            v-bind="attrs"
            v-on="on"
            flat
            solo
            hide-details
            single-line
            :type="type"
            v-model="value"
            class="input-custom py-0 pl-5 pr-0"
            :class="{ disabledInput: disabled }"
          >
          </v-text-field>
        </template>
        <v-date-picker v-model="value" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">
            {{ $t("user.cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save()">
            {{ $t("user.ok") }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import config from "@/config/app-config";

export default {
  props: {
    inputTitle: String,
    type: {
      value: String,
      default: "text",
    },
    key_index: String,
    disabled: Boolean,
  },
  data: () => ({
    modal: false,
    config,
    value: null,
    first: false,
  }),
  methods: {
    clearInput() {
      this.value = "";
    },
  },
  created() {
    if (this.type == "date") {
      this.value = this.userData.userData.birthday
        ? window
            .moment(this.userData.userData.birthday)
            .add(1, "days")
            .format("yyyy-MM-DD")
        : "";
    } else {
      this.value = this.userData.userData[this.key_index];
    }
  },
  computed: {
    ...mapState(["userData"]),
  },
  watch: {
    value(val) {
      if (this.type == "date") {
        val = new Date(val + "T00:00:00.000Z").toISOString();
      }
      if (!this.disabled && this.first)
        this.$store.commit("setField", {
          field: this.key_index.replace(/([A-Z])/g, "_$1").toLowerCase(),
          value: val,
        });

      this.first = true;
    },
  },
};
</script>
<style lang="scss">
.disabledInput {
  background-color: var(--secondary-color);
}
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none;
}
.v-text-field.v-text-field--solo .v-input__control input {
  color: var(--primary-color);
}
</style>
